<template>
  <v-container
    class="mx-auto pa-0"
  >
    <v-row no-gutters justify="center">
      <v-chip
        class="mr-2 mb-2"
        label
        :style="vChipStyle('time')"
        :dark="isCurrentPage('time')"
        :outlined="!isCurrentPage('time')"
        color="doorMainColor"
        :small="isSmall"
      >
        実施時期
      </v-chip>
      <v-icon class="mr-2" color="doorMainColor">
        mdi-chevron-double-right
      </v-icon>
      <v-chip
        class="mr-2 mb-2"
        label
        :style="vChipStyle('patient')"
        :dark="isCurrentPage('patient')"
        :outlined="!isCurrentPage('patient')"
        color="doorMainColor"
        :small="isSmall"
      >
        患者情報
      </v-chip>
      <v-icon class="mr-2" color="doorMainColor">
        mdi-chevron-double-right
      </v-icon>
      <v-chip
        class="mr-2 mb-2"
        label
        :style="vChipStyle('consultation')"
        :dark="isCurrentPage('consultation')"
        :outlined="!isCurrentPage('consultation')"
        color="doorMainColor"
        :small="isSmall"
      >
        診察
      </v-chip>
      <v-icon class="mr-2" color="doorMainColor">
        mdi-chevron-double-right
      </v-icon>
      <v-chip
        class="mr-2 mb-2"
        label
        :style="vChipStyle('assessment')"
        :dark="isCurrentPage('assessment')"
        :outlined="!isCurrentPage('assessment')"
        color="doorMainColor"
        :small="isSmall"
      >
        アセスメント
      </v-chip>
      <v-icon class="mr-2" color="doorMainColor">
        mdi-chevron-double-right
      </v-icon>
      <v-chip
        class="mr-2 mb-2"
        label
        :style="vChipStyle('plan')"
        :dark="isCurrentPage('plan')"
        :outlined="!isCurrentPage('plan')"
        color="doorMainColor"
        :small="isSmall"
      >
        プラン
      </v-chip>
      <v-icon class="mr-2" color="doorMainColor">
        mdi-chevron-double-right
      </v-icon>
      <v-chip
        class="mr-2 mb-2"
        label
        :style="vChipStyle('done')"
        :dark="isCurrentPage('done')"
        :outlined="!isCurrentPage('done')"
        color="doorMainColor"
        :small="isSmall"
      >
        完了
      </v-chip>
    </v-row>
  </v-container>
</template>
<script>
import { defineComponent, computed } from 'vue'
import { useDisplay } from 'vuetify'

export default defineComponent({
  props: {
    page: {
      type: String,
      require: true,
    },
  },
  setup(props) {
    const { mobile } = useDisplay()

    const isMobile = () => {
      return mobile.value
    }

    const isCurrentPage = (page) => {
      return page == props.page
    }

    const minWidth = computed(() => {
      return isMobile() ? '20px' : '124px'
    })

    const isSmall = computed(() => {
      return isMobile()
    })

    const vChipStyle = (page) => {
        return isCurrentPage(page)
          ? 'min-width: ' + minWidth.value + '; justify-content: center; font-weight: bold;'
          : 'min-width: ' + minWidth.value + '; justify-content: center;';
    }

    return {
      isMobile,
      isCurrentPage,
      minWidth,
      isSmall,
      vChipStyle
    }
  }
})
</script>
